import api from '../../../config/axios-interceptor';

/*
 * The rota, on its own endpoints.
 *
 * Deliberately NOT /api/v1/operator/*. Those carry create, delete, set-password and an update that
 * can write operators.email — and that column is what every ownership check in the product compares
 * against the authenticated username. A screen that only sets working hours has no business holding
 * a client for endpoints that can do any of that, and a supervisor is refused them anyway.
 */

export const fetchSchedules = async () => {
    try {
        return await api.get('/api/v1/operator-schedule/find-all');
    } catch (error) {
        console.error('Error fetching schedules:', error);
        throw error;
    }
};

/**
 * Replace one operator's whole week.
 *
 * The complete week is always sent, because the backend replaces rather than merges — that is what
 * makes removing a shift possible. It refuses a missing list outright rather than reading it as
 * "clear the rota", which is the mistake that used to wipe schedules silently.
 */
export const saveSchedule = async (operatorId, workSchedule) => {
    try {
        return await api.put(`/api/v1/operator-schedule/${operatorId}`, {workSchedule});
    } catch (error) {
        console.error('Error saving schedule:', error);
        throw error;
    }
};
